import { useReducer } from 'react'
import effects from 'app/effects/effects'
import { usePlace } from 'commons/usePlace'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

export const actionMessageType = {
  SET_AUTOMATED_CALL_SETTING: 'SET_AUTOMATED_CALL_SETTING',
  IS_LOADING_AUTOMATED_CALL: 'IS_LOADING_AUTOMATED_CALL',
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionMessageType.IS_LOADING_AUTOMATED_CALL:
      return {
        ...state,
        isLoadingAutomatedCallSetting: true,
      }
    case actionMessageType.SET_AUTOMATED_CALL_SETTING:
      return {
        ...state,
        automatedCallSetting: action.automatedCallSetting,
        isLoadingAutomatedCallSetting: false,
      }
    default:
      return state
  }
}

const initialState = {
  automatedCallSetting: {},
  isLoadingAutomatedCallSetting: false,
}

export const useManageChannelsContent = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const dispatchs = useDispatch()
  const { formatMessage } = useIntl()
  const place = usePlace()

  const setLoading = () => {
    dispatch({ type: actionMessageType.IS_LOADING_AUTOMATED_CALL })
  }

  const fetchAutomatedCallSetting = () => {
    effects.apis
      .getAutomatedCallSetting({
        placeId: place.id,
      })
      .then((res) => {
        dispatch({
          type: actionMessageType.SET_AUTOMATED_CALL_SETTING,
          automatedCallSetting: res,
        })
      })
      .catch((error) => {
        dispatchs(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }

  return {
    state,
    fetchAutomatedCallSetting,
    setLoading,
  }
}
